import React from 'react'
import PropTypes from 'prop-types';
import './style.css';
import Marquee from "react-fast-marquee";

const TickerComponent2 = ({ data }) => {
  return (
    <>
      <div className="bubble">
        Announcement
      </div>
      <Marquee gradient={false} speed={50} pauseOnHover>
        {
          data?.map((item, index) => {
            return (
              <div key={`key_${index}`}>
                <h6 className="tick-heading" key={item?.id}>
                  {item?.Link ?
                    <>
                      <a href={item.Link} target="_blank" className='tick-hyperlink' rel="noreferrer">
                        {item?.title}
                      </a>
                    </> :
                    item?.title}
                </h6>
              </div>
            )
          })
        }
      </Marquee>
    </>
  )
}

export default TickerComponent2
TickerComponent2.propTypes = {
  data: PropTypes.array
}

